import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Panel,
          Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          FormControl,
          ControlLabel,
          Table,
          Checkbox,
          Glyphicon,
          Modal,
          ButtonGroup,
          DropdownButton,
          MenuItem,
          Tooltip,
          OverlayTrigger,
          Image,} from "react-bootstrap";
import Truncate from 'react-truncate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker from 'react-16-bootstrap-date-picker';//has min/maxDate but no time
import Datetime from 'react-datetime';//has time but no min/maxDate
import {ToastContainer, ToastStore} from 'react-toasts';
import moment from 'moment';

import _ from "underscore";
import $ from "jquery";

//props
//elements
//setImagesToUpload
class FormCanvas extends Component {

  constructor(props, context) {
      super(props, context);
      this.state = {
        blobImg: null,
        cloneGroups: {},//List of cloneGroups and their count. ex: {"Occurrence": 2}
      }
      this.processFields = this.processFields.bind(this);
  }
  render() {
    return <Col id="canvasWindow" style={{padding: 30, minHeight: 700, marginTop: 10, marginBottom: 30, marginLeft: 10, marginRight: 10}}>
            {this.processFields(this.props.elements)}
          </Col>;
  }

  processFields(data, parentElement) {
    var content =[];
    var disabled = this.props.mode === "edit" || this.props.mode === "readOnly";
    var isReadOnly = this.props.mode === "readOnly";
    var width = null;
    var mode = this.props.mode;

    if(data != null) {
      data.map((field, index)=>{
        switch(field.type) {
          case "textInput":

            content.push(<FormGroup key={field.id + '_' + index} controlId={field.id}
                              className={field.className
                                                                                                                ? field.className.value
                                                                                                                    ? field.className.value
                                                                                                                    : field.className
                                                                                                                : "col-md-12"}
                              onClick={(e)=>{e.stopPropagation();this.props.selectElement(index, field.id, parentElement)}}
                              style={{backgroundColor: this.props.selectedIndex == index && this.props.selectedId == field.id ? "#ffa663" : null, padding: 5, borderRadius: 5}}>
                              <ControlLabel className="login_label">{field.label}
                              {this.renderMoveUpButton(index, field.id, parentElement)}
                              {this.renderMoveDownButton(index, field.id, parentElement)}
                              {this.renderDeleteButton(index, field.id, parentElement)}</ControlLabel>
                              <FormControl
                                  disabled={disabled}
                                  autoFocus
                                  style={{border: isReadOnly ? 0 : null, cursor: isReadOnly ? "default" : null}}
                                  type="text"
                                  value={field.value}
                                  onChange={(e)=>{this.handleChange(e, "textInput", field, index)}}
                              />
                          </FormGroup>)
          break;

          case "text":
            content.push(<FormGroup key={field.id + '_' + index} controlId={field.id} bsSize="md"
                              className={field.className
                                              ? field.className.value
                                                  ? field.className.value
                                                  : field.className
                                              : "col-md-12"}
                              onClick={(e)=>{e.stopPropagation();this.props.selectElement(index, field.id, parentElement)}}
                              style={{textAlign: "center", backgroundColor: this.props.selectedIndex == index && this.props.selectedId == field.id ? "#ffa663" : null, padding: 5, borderRadius: 5}}>
                              <Row style={{fontSize: parseInt(field.fontSize), paddingLeft: parseInt(field.paddingLeft), paddingRight: parseInt(field.paddingRight),color: field.fontColor, textAlign: field.textAlign}}>
                              {field.text}
                              {this.renderMoveUpButton(index, field.id, parentElement)}
                              {this.renderMoveDownButton(index, field.id, parentElement)}
                              {this.renderDeleteButton(index, field.id, parentElement)}
                              </Row>
                            </FormGroup>)
          break;

          case "textArea":
            content.push(<FormGroup key={field.id + '_' + index} controlId={field.id} bsSize="md" className={field.className
                                                                                                                ? field.className.value
                                                                                                                    ? field.className.value
                                                                                                                    : field.className
                                                                                                                : "col-md-12"}
                              onClick={(e)=>{e.stopPropagation(); this.props.selectElement(index, field.id, parentElement)}}
                              style={{textAlign: "center", backgroundColor: this.props.selectedIndex == index && this.props.selectedId == field.id ? "#ffa663" : null, padding: 5, borderRadius: 5}}>
                          <ControlLabel className="login_label">{field.label}
                          {this.renderMoveUpButton(index, field.id, parentElement)}
                          {this.renderMoveDownButton(index, field.id, parentElement)}
                          {this.renderDeleteButton(index, field.id, parentElement)}</ControlLabel>
                          <FormControl disabled={disabled} componentClass="textarea"
                                        placeholder={field.placeholder}
                                        style={{border: isReadOnly ? 0 : null, cursor: isReadOnly ? "default" : null}}
                                        rows={parseInt(field.lines.value ? field.lines.value : field.lines)}
                                        value={field.value}
                                        onChange={(e)=>{this.handleChange(e, "textInput", field, index)}} />
                        </FormGroup>);
          break;

          case "dateField":
              const value = field.value ? moment(field.value).format() : null;
              
              content.push(<FormGroup key={field.id + '_' + index} controlId={field.id+"_formGroup"}
                                      className={field.className
                                                      ? field.className.value
                                                          ? field.className.value
                                                          : field.className
                                                      : "col-md-12"}
                                      onClick={(e)=>{e.stopPropagation();this.props.selectElement(index, field.id, parentElement)}}
                                      style={{backgroundColor: this.props.selectedIndex == index && this.props.selectedId == field.id ? "#ffa663" : null, padding: 5, borderRadius: 5}}>
                              <ControlLabel htmlFor={field.id}>{field.label}
                              {this.renderMoveUpButton(index, field.id, parentElement)}
                              {this.renderMoveDownButton(index, field.id, parentElement)}
                              {this.renderDeleteButton(index, field.id, parentElement)}</ControlLabel>
                              <DatePicker
                                  id={field.id}
                                  disabled={disabled}
                                  dateFormat={field.dateFormat.value}
                                  style={{border: isReadOnly ? 0 : null, cursor: isReadOnly ? "default" : null}}
                                  onChange={(e)=> {
                                    const value = moment(e).format('MM/DD/YYYY');
                                    const fakeEvent = {currentTarget: { id: field.id, value: value}};
                                      this.handleChange(fakeEvent, "textInput", field, index);
                                    }}
                                  value={value}
                                  calendarIcon={null}
                                  clearIcon={null}
                                  />

                                  {
                                    //has time but no minDate MaxDate, used in renderInputs() here for fake DAR.. Kapos kapalaran, humanap nang iba na pkg goro.siguro
                                    // <Datetime
                                    // style={{}}
                                    // onChange={(e)=>{
                                    //   newNewForm.occurrences[i]["occurrenceDate"] = e;
                                    //   this.setState({newForm: newNewForm});}}/>
                                  }

                          </FormGroup>)
          break;

          case "fileUpload":
            var imgSrc = null;
            var imagesToUpload = this.props.imagesToUpload;
            if(imagesToUpload != null && imagesToUpload.length > 0 && this.state.blobImg == null) {

              try{
                //For local imgs
                imgSrc = [URL.createObjectURL(imagesToUpload[0])];
              } catch(e) {
                 imagesToUpload = JSON.parse(this.props.imagesToUpload);
                //for imgs from db
                if(typeof(imagesToUpload[0]) != "undefined"){
                  imgSrc = imagesToUpload[0].path;

                  fetch(imgSrc)
                  .then(function(response) {
                    return response.blob()
                  })
                  .then(function(blob) {
                    // here the image is a blob
                    this.setState({
                      blobImg: blob
                    })
                  })
                  .catch((e)=>{
                    console.log("Fetch blob failure: ", e);
                  });
                }


                //imgSrc = new File(imagesToUpload[0].path], "name");
              }

            } else {
              imgSrc = this.state.blobImg
            }
            content.push(<FormGroup key={field.id + '_' + index} controlId={field.id} bsSize="md" className={field.className
                                                                                                                ? field.className.value
                                                                                                                    ? field.className.value
                                                                                                                    : field.className
                                                                                                                : "col-md-12"}
                              onClick={(e)=>{e.stopPropagation(); this.props.selectElement(index, field.id, parentElement)}}
                              style={{textAlign: "center", backgroundColor: this.props.selectedIndex == index && this.props.selectedId == field.id ? "#ffa663" : null, padding: 5, borderRadius: 5}}>

                          <ControlLabel className="login_label">
                          {this.renderMoveUpButton(index, field.id, parentElement)}
                          {this.renderMoveDownButton(index, field.id, parentElement)}
                          {this.renderDeleteButton(index, field.id, parentElement)}</ControlLabel>
                          {
                            imagesToUpload != null && imagesToUpload.length > 0
                            ? <div>
                                  <Image className={"col-md-12"} src={imgSrc} fluid={"true"} rounded />
                              </div>
                            : null
                          }

                          { mode != "readOnly"
                                ? <Button variant="primary" size="lg" className={"col-md-12"}
                                    onClick={(e)=>{
                                            if(disabled) {
                                              e.stopPropagation();
                                              this.props.selectElement(index, field.id, parentElement);
                                            }

                                     }}>
                                        <input style={{display: "hidden"}} ref={input => this.imageAttachment = input} id={field.id} type="file"
                                                disabled={disabled}
                                                onChange={(e)=>{console.log("selectImage: ", e.target.files);
                                                this.props.setImagesToUpload(e.target.files)
                                                  }} />
                                  </Button>
                                : null
                          }
                        </FormGroup>);
          break;

          case "button":
          if(mode != "readOnly") {
            var isSubmitButton = field.buttonType.value === "Submit"
            content.push(<div className={field.className
                                          ? field.className.value
                                              ? field.className.value
                                              : field.className
                                          : "col-md-2"}
                                style={{backgroundColor: this.props.selectedIndex == index && this.props.selectedId == field.id ? "#ffa663" : null, paddingLeft: parseInt(field.paddingLeft), paddingRight: parseInt(field.paddingRight),color: field.fontColor, textAlign: field.textAlign}}>
                                {this.renderMoveUpButton(index, field.id, parentElement)}
                                {this.renderMoveDownButton(index, field.id, parentElement)}
                                {this.renderDeleteButton(index, field.id, parentElement)}

                                <Button
                                  className={field.btnClassName
                                                                ? field.btnClassName.value
                                                                    ? field.btnClassName.value
                                                                    : field.btnClassName
                                                                : "col-md-12"}
                                  style={{marginTop: 15, marginBottom: 15 }}
                                  onClick={(e)=>{
                                      if(disabled) {
                                        e.stopPropagation();
                                        this.props.selectElement(index, field.id, parentElement);
                                      } else {
                                        if(field.buttonType.value == "Submit") {
                                          this.props.onSave(JSON.stringify(this.props.elements), this.props.imagesToUpload);
                                        } else {
                                          this.props.repeatElement(field.groupToRepeat.value);
                                        }
                                      }

                                    }}>{isSubmitButton && mode === "fillUpdate"
                                                  ? "Save"
                                                  : field.text}</Button>

                                </div>)
          }

          break;

          case "select":
          var choices = field.choices.value;

          //props.clients already repacked
          if(field.buttonType.value == "Client") {
            choices = _.filter(this.props.clients, (client)=>{ return client.isActive});
          }
            content.push(<FormGroup key={field.id + '_' + index} controlId={field.id} bsSize="md" className={field.className
                                                                                                                ? field.className.value
                                                                                                                    ? field.className.value
                                                                                                                    : field.className
                                                                                                                : "col-md-12"}
                                          onClick={()=>{this.props.selectElement(index, field.id, parentElement)}}
                                          style={{textAlign: "center", backgroundColor: this.props.selectedIndex == index && this.props.selectedId == field.id ? "#ffa663" : null, padding: 5, borderRadius: 5}}>
                                          <ControlLabel className="login_label">{field.label}
                                          {this.renderMoveUpButton(index, field.id, parentElement)}
                                          {this.renderMoveDownButton(index, field.id, parentElement)}
                                          {this.renderDeleteButton(index, field.id, parentElement)}</ControlLabel>
                          <FormControl  componentClass="select" placeholder="Client"
                                        style={{width: "100%"}}
                                        defaultValue={""}
                                        disabled={disabled}
                                        style={{border: isReadOnly ? 0 : null, cursor: isReadOnly ? "default" : null}}
                                        value={field.value}
                                        onChange={(e)=>{this.handleChange(e, "select", field, index)}}>
                                        {choices.length > 0
                                              ? <option disabled selected value={""}>Select {field.buttonType.value == "Default" ? "Option" : field.buttonType.value}</option>
                                              : <option disabled selected value={""}>No Options</option> }
                                        {choices.map((choice, index)=>{
                                            return <option key={index} value={choice.id}>{choice.name}</option>
                                          })
                                        }
                          </FormControl>
                        </FormGroup>);

          break;

          case "column":
            var parentWidth = field.parentElement ? $("#"+field.parentElement.id).width() : $("#canvasWindow").width();
            var backgroundColor = null;
            var width = field.width != null && field.width.value !== ""
                                              ? parentWidth * (parseFloat(field.width.value))
                                              : null;

            if(this.props.selectedIndex == index && field.id == this.props.selectedId) {
              backgroundColor = "#ffa663";
            } else if(field.children.length <= 0) {
              backgroundColor = "#e1e5ed";
            }

            content.push(<div key={field.id + '_' + index}
                              className={field.className
                                            ? field.className.value
                                                ? field.className.value
                                                : field.className
                                            : "col-md-12"}
                               style={{minHeight: field.height.value == 'max' ? window.innerHeight + 'px' : parseInt(field.height.value), backgroundColor: backgroundColor, width: width}}>

                              {field.children.length <= 0
                                ? "Column"
                                : null}
                              {!disabled && field.isClone ? this.renderDeleteButton(index, field.id, parentElement, true) : null}

                              {this.renderMoveUpButton(index, field.id, parentElement)}
                              {this.renderMoveDownButton(index, field.id, parentElement)}
                              {this.renderDeleteButton(index, field.id, parentElement)}
                              {this.renderContainerSelector(index, field.id, parentElement)}
                              {field.children.length > 0
                                ? this.processFields(field.children, field)
                                : null
                              }


                              </div>)
          break;

          case "container":
            var parentWidth = field.parentElement ? $("#"+field.parentElement.id).width() : $("#canvasWindow").width();
            var backgroundColor = null;
            var width = field.width != null && field.width.value !== ""
                                              ? parentWidth * (parseFloat(field.width.value))
                                              : null;

            if(this.props.selectedIndex == index && field.id == this.props.selectedId) {
              backgroundColor = "#ffa663";
            } else if(field.children.length <= 0) {
              backgroundColor = "#e1e5ed";
            }

            content.push(<div key={field.id + '_' + index}
                              className={field.className
                                            ? field.className.value
                                                ? field.className.value
                                                : field.className
                                            : "col-md-12"}
                               style={{minHeight: field.height.value == 'max' ? window.innerHeight + 'px' : parseInt(field.height.value), backgroundColor: backgroundColor, width: width}}>

                              {field.children.length <= 0
                                ? "Container"
                                : null}
                              {!disabled && field.isClone ? this.renderDeleteButton(index, field.id, parentElement, true) : disabled}

                              {this.renderMoveUpButton(index, field.id, parentElement)}
                              {this.renderMoveDownButton(index, field.id, parentElement)}
                              {this.renderDeleteButton(index, field.id, parentElement)}
                              {this.renderContainerSelector(index, field.id, parentElement)}
                              {field.children.length > 0
                                ? this.processFields(field.children, field)
                                : null
                              }


                              </div>)
          break;

          default:
            content.push(<FormGroup key={field.id + '_' + index} controlId={field.id} >
                      <div>Unknown field: {field.type} {this.renderDeleteButton(index)}</div>
                      </FormGroup>);
          break;
        }
      });
    } else {
      content.push(<Row key={"empty_form"}>Field list is empty! This form appears to be not built by the Form Builder and couldn't be loaded.</Row>)
    }


    return <Col>{content}</Col>

  }

  renderDeleteButton(index, id, parentElement, override) {

    //Work on deleting children from col and row
    return ((this.props.selectedIndex == index && this.props.selectedId == id) || override)
      ? <Glyphicon glyph="remove" className={override ? "pull-right" : null}style={{marginLeft: 10, cursor: "pointer"}}
          onClick={()=>{
            if(override) {
              var cloneGroup = parentElement != null ? parentElement.children[index].cloneGroup.value : this.props.elements[index].cloneGroup.value;
              this.props.removeElement(index, parentElement, cloneGroup);
            } else {
              this.props.removeElement(index, parentElement);
            }

          }}/>
       : null;
  }

  renderContainerSelector(index, id, parentElement) {
    return (this.props.selectedIndex != index || this.props.selectedId != id) && this.props.mode == "edit"
      ? <Row><Glyphicon glyph="hand-up" style={{marginLeft: 10, cursor: "pointer"}}
          onClick={()=>{
            this.props.selectElement(index, id, parentElement);
          }}/></Row>
       : null;
  }

  renderMoveUpButton(index, id, parentElement) {
    return this.props.selectedIndex == index && this.props.selectedId == id
      ? <Glyphicon glyph="arrow-up" style={{marginLeft: 10, cursor: "pointer"}}
          onClick={()=>{
            this.props.moveElement(index, -1, parentElement);
          }}/>
       : null;
  }

  renderMoveDownButton(index, id, parentElement) {
    return this.props.selectedIndex == index && this.props.selectedId == id
      ? <Glyphicon glyph="arrow-down" style={{marginLeft: 10, cursor: "pointer"}}
          onClick={()=>{
            this.props.moveElement(index, 1, parentElement);
          }}/>
       : null;
  }

  handleChange(e, type, field, index) {
    switch(type) {
      case "textInput":
        // var newState ={};
        // newState[id] = e.currentTarget.value;
        // this.setState(newState);
        var newElement = field;
        newElement.value = e.currentTarget.value;
        var customParentElement = null;
        var newChildren = [];

        //Update parentElement's children to include the newly edited child
        if(newElement.parentElement != null) {
          customParentElement = JSON.parse(JSON.stringify(newElement.parentElement));
          customParentElement.children.splice(index, 1, newElement);
        }

        this.props.updateElement(index, newElement, customParentElement);
      break;
      case "select":
        var newElement = field;
        newElement.value = e.currentTarget.value;
        var customParentElement = null;
        var newChildren = [];
        //Update parentElement's children to include the newly edited child
        if(newElement.parentElement != null) {
          customParentElement = JSON.parse(JSON.stringify(newElement.parentElement));
          customParentElement.children.splice(index, 1, newElement);
        }
        this.props.updateElement(index, newElement, customParentElement)
      break;
      default:
      break;
    }
  }



}

export default FormCanvas;
